/**
 * Build-time configuration for the business card app.
 *
 * WHY THIS FILE EXISTS
 *
 * IntroPage.jsx previously contained five copies of the literal
 * `https://pro.healthcare.tiryaqapp.com`, one per professional type. That was wrong in three ways:
 *
 *   1. It hardcoded another application's public hostname into this bundle, so moving or renaming
 *      the professional console meant editing and redeploying THIS repository.
 *   2. The host it named, `pro.healthcare.tiryaqapp.com`, is not the host the professional console
 *      is deployed on — that is `professionals.healthcare.tiryaqapp.com`. Every one of the five
 *      buttons would have sent the user to a name that does not resolve.
 *   3. Being a literal, it could not differ between environments: a staging build and a production
 *      build would both navigate to production.
 *
 * The value now comes from REACT_APP_PROFESSIONAL_APP_URL, supplied by the Terraform
 * `frontend_build_environment_overlay` and baked in by CodeBuild. Create React App inlines
 * REACT_APP_* at BUILD time, so changing it requires a rebuild, not a redeploy.
 */

// Trailing slashes stripped so `${base}${route}` cannot produce a double slash.
export const PROFESSIONAL_APP_URL = (
  process.env.REACT_APP_PROFESSIONAL_APP_URL || ''
).replace(/\/+$/, '');

/**
 * Selected option -> route in the professional console.
 *
 * Keys are the values IntroPage's radio group sets. Routes are verified against the professional
 * frontend's App.js route table.
 */
export const PROFESSIONAL_DASHBOARD_ROUTES = {
  doctor: '/doctor-dash',
  pharmacy: '/pharmacy-dash',
  'doctor-home-consultation': '/doctor-home-consultation-dash',
  nurse: '/nurse-form-dash',
  'physiotherapy-imaging-lab': '/physiotherapy-form-dash',
};

/**
 * Tiryaq Professional consultation registration link: /consultation-registration on this app.
 *
 * It offers only the doctor online / home consultation options and sends them straight to the
 * console's dedicated forms (no intro slides). Those forms submit to the endpoint where the API
 * gateway records the registration source. ROUTES must match the console's
 * CONSULTATION_REGISTRATION.ROUTE_PREFIX routes in the professional frontend's App.js.
 */
export const CONSULTATION_REGISTRATION = {
  ROUTE: '/consultation-registration',
  TITLE: 'Tiryaq Professional',
  ROUTES: {
    doctor: '/consultation-registration/doctor-form',
    'doctor-home-consultation': '/consultation-registration/doctor-home-consultation-form',
  },
};

/**
 * Absolute URL for a professional type, or null when the option or the configuration is missing.
 * `routes` is the page's option -> console route map (the main page's by default).
 *
 * Returning null rather than a relative path is deliberate. If REACT_APP_PROFESSIONAL_APP_URL were
 * absent, a relative `/doctor-dash` would navigate within the business card app and render its own
 * 404 — a broken-looking page with no indication that a build variable is missing. Null lets the
 * caller say so instead.
 */
export const professionalDashboardUrl = (option, routes = PROFESSIONAL_DASHBOARD_ROUTES) => {
  console.log('option :', option)
  console.log('PROFESSIONAL_DASHBOARD_ROUTES :', routes)
  const route = routes[option];
  console.log('PROFESSIONAL_APP_URL :', PROFESSIONAL_APP_URL)

  if (!route || !PROFESSIONAL_APP_URL) {
    return null;
  }

  return `${PROFESSIONAL_APP_URL}${route}`;
};

/**
 * Support contact shown by SupportContact.jsx under the role card. WHATSAPP_URL is WhatsApp's
 * click-to-chat link, which takes the number in international format as digits only.
 */
const SUPPORT_WHATSAPP_NUMBER = '+964 789 009 9556';

export const SUPPORT_CONTACT = {
  WHATSAPP_NUMBER: SUPPORT_WHATSAPP_NUMBER,
  WHATSAPP_URL: `https://wa.me/${SUPPORT_WHATSAPP_NUMBER.replace(/\D/g, '')}`,
};
